import React from 'react';
import img2 from '../../assets/logos/img2.png';

import './Modal.css';

const Modal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <div className="profile-modal1-left">
            <img src={img2} alt="img2" className="profile-modal1-img" />
          </div>
          <div className="profile-right">
            <div class="cv-section">
              <h2>Poplavsky International Offices DMCC</h2>
              <p>Nos especializamos en:</p>

              <h3>Derecho Penal y Penal Internacional</h3>
              <p>Hoy nos encontramos en un mundo globalizado, donde los delitos no tienen fronteras y se debe actuar, muchas veces, en más de un país al mismo tiempo.</p>

              <h3>Derecho Internacional Privado</h3>
              <p>Para hacer frente a las relaciones personales y comerciales que trascienden nuestras fronteras, se requiere conocimiento en normativa internacional y profesionales especialmente capacitados.</p>

              <h3>Derecho Laboral</h3>
              <p>Esta área asesora legalmente y acompaña a empleadores en asuntos de derecho colectivo e individual del trabajo.</p>

              <h3>Derecho Tributario</h3>
              <p>Afrontando la situación mundial y de Argentina, ofrecemos asesoramiento integral en temas tributarios internos y de doble tributación.</p>

              <h3>Sociedades en el Extranjero</h3>
              <p>En un mundo globalizado, las relaciones comerciales no conocen fronteras. Brindamos asesoramiento completo para materializar sus proyectos de manera rápida, concreta y segura.</p>

              <h3>Inversiones en el Extranjero</h3>
              <p>Desde nuestra sede en Brickell, Florida, ofrecemos servicios en inversiones internacionales inmobiliarias y comerciales.</p>

              <h3>Compliance & Criptomonedas</h3>
              <p>El mercado de criptodivisas está revolucionando el ámbito financiero global, planteando nuevos desafíos legales que requieren soluciones seguras y ajustadas a normas jurídicas estrictas.</p>

              <h3>Visas y Ciudadanías</h3>
              <p>Contamos con profesionales especializados para tramitar visas de inmigrante y no inmigrante en Estados Unidos, así como la ciudadanía italiana, cuando se cumplen los requisitos.</p>

              <h3>Propiedad Intelectual</h3>
              <p>En un mundo competitivo, asistimos a nuestros clientes en todos los asuntos relacionados con la propiedad intelectual en Argentina y a nivel global.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
